/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Message_To_Reply_ToInputs */

const en_no_message_to_reply_to = /** @type {(inputs: No_Message_To_Reply_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No message to reply to!`)
};

const es_no_message_to_reply_to = /** @type {(inputs: No_Message_To_Reply_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡No hay mensaje para responder!`)
};

const fr_no_message_to_reply_to = /** @type {(inputs: No_Message_To_Reply_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun message auquel répondre !`)
};

const de_no_message_to_reply_to = /** @type {(inputs: No_Message_To_Reply_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Nachricht, auf die geantwortet werden kann!`)
};

const ja_no_message_to_reply_to = /** @type {(inputs: No_Message_To_Reply_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返信するメッセージがありません！`)
};

const zh_no_message_to_reply_to = /** @type {(inputs: No_Message_To_Reply_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有要回复的消息！`)
};

const ar_no_message_to_reply_to = /** @type {(inputs: No_Message_To_Reply_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد رسالة للرد عليها!`)
};

const id_no_message_to_reply_to = /** @type {(inputs: No_Message_To_Reply_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada pesan untuk dibalas!`)
};

const it_no_message_to_reply_to = /** @type {(inputs: No_Message_To_Reply_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun messaggio a cui rispondere!`)
};

const ru_no_message_to_reply_to = /** @type {(inputs: No_Message_To_Reply_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет сообщения для ответа!`)
};

const pt_no_message_to_reply_to = /** @type {(inputs: No_Message_To_Reply_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma mensagem para responder!`)
};

const ko_no_message_to_reply_to = /** @type {(inputs: No_Message_To_Reply_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`답장할 메시지가 없습니다!`)
};

/**
* | output |
* | --- |
* | "No message to reply to!" |
*
* @param {No_Message_To_Reply_ToInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const no_message_to_reply_to = /** @type {((inputs?: No_Message_To_Reply_ToInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Message_To_Reply_ToInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_message_to_reply_to(inputs)
	if (locale === "es") return es_no_message_to_reply_to(inputs)
	if (locale === "fr") return fr_no_message_to_reply_to(inputs)
	if (locale === "de") return de_no_message_to_reply_to(inputs)
	if (locale === "ja") return ja_no_message_to_reply_to(inputs)
	if (locale === "zh") return zh_no_message_to_reply_to(inputs)
	if (locale === "ar") return ar_no_message_to_reply_to(inputs)
	if (locale === "id") return id_no_message_to_reply_to(inputs)
	if (locale === "it") return it_no_message_to_reply_to(inputs)
	if (locale === "ru") return ru_no_message_to_reply_to(inputs)
	if (locale === "pt") return pt_no_message_to_reply_to(inputs)
	return ko_no_message_to_reply_to(inputs)
});